(function () {
  'use strict';

  const { scrollToElement } = window.Universe;

  class ScrollTo {
    constructor() {
      this.init();
    }

    scrollLinkTo(e) {
      e.preventDefault();

      const currentTarget = e.currentTarget;
      const targetId = currentTarget.getAttribute('href');
      const target = document.querySelector(targetId);

      if (target) {
        scrollToElement(target, 100);
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }

    setup() {
      for (let i = 0; i < this.DOM.hashElements.length; i++) {
        this.DOM.hashElements[i].addEventListener('click', this.scrollLinkTo);
      }

      document.addEventListener('click', (e) => {
        if (e.target.closest('.js-hash-scroll')) {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    }

    reinit(container) {
      this.destroy();
      this.init(container);
    }

    destroy() {
      if (this.DOM) {
        for (let i = 0; i < this.DOM.hashElements.length; i++) {
          this.DOM.hashElements[i].removeEventListener('click', this.scrollLinkTo);
        }

        this.DOM = undefined;
      }
    }

    init(container) {
      container = container || document;
      const hashElements = container.querySelectorAll('.js-hash-scroll');

      if (hashElements.length > 0) {
        this.DOM = {};
        this.DOM.hashElements = hashElements;

        this.scrollLinkTo = this.scrollLinkTo.bind(this);

        this.setup();
      }
    }
  }

  window.Universe.ScrollTo = ScrollTo;
})();
